export default "__VITE_PUBLIC_ASSET__84d18619__"